import React, { type SVGProps } from "react";

/** Figma «File / File_Download» — the chat drop overlay's glyph. The photo classifier draws the
 *  redesign upload icon instead (`UploadIcon`); this one is chat's. */
export function FileDropIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 35 44" fill="none" aria-hidden {...props}>
      <path
        d="M17.25 19.75L17.25 33.25M11.5 28.75L17.25 33.25L23 28.75M33.0004 15H26.7004C24.1802 15 22.9191 14.9999 21.9565 14.5095C21.1098 14.078 20.4219 13.3897 19.9905 12.5429C19.5 11.5803 19.5 10.3202 19.5 7.8V1.5M33 34.8V15.7324C33 14.6317 32.9991 14.0813 32.8748 13.5634C32.7645 13.1042 32.5831 12.6653 32.3363 12.2627C32.0581 11.8086 31.67 11.4194 30.8917 10.6412L23.8594 3.60883C23.0811 2.83055 22.6919 2.44145 22.2378 2.16316C21.8352 1.91643 21.3964 1.73457 20.9372 1.62434C20.4193 1.5 19.8688 1.5 18.7681 1.5H8.70044C6.1802 1.5 4.91915 1.5 3.95654 1.99047C3.10981 2.4219 2.4219 3.11036 1.99047 3.95709C1.5 4.9197 1.5 6.17979 1.5 8.70003V34.8C1.5 37.3203 1.5 38.5803 1.99047 39.5429C2.4219 40.3897 3.10981 41.078 3.95654 41.5095C4.91915 41.9999 6.1802 42 8.70044 42H25.8004C28.3207 42 29.5799 41.9999 30.5425 41.5095C31.3892 41.078 32.0786 40.3897 32.51 39.5429C33.0005 38.5803 33 37.3203 33 34.8Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
